import Vue from 'vue'
import Router from 'vue-router'
import * as types from '@/types'
import store from '../store/store.js'
import fxViewcomponents from '@/components/fxView' 
//====================bank==================================================
import bank from '@/components/fxView/bank/bank'
//====================users=================================================
import landingPage from '@/components/fxView/lp/demo-account'
import login from '@/components/fxView/users/login'
import register from '@/components/fxView/users/register'
import twoFa from '@/components/fxView/users/2FA'
import profile from '@/components/fxView/users/profile'

import forgotPassword from '@/components/fxView/users/forgot_password'
import notification from '@/components/fxView/users/user_notification'
import ResetPasswordFromHash from '@/components/fxView/users/ResetPasswordFromHash'
import request_verify from '@/components/fxView/users/request_verify'
import dashboard from '@/components/fxView/users/dashboard'
import changeUserPassword from '@/components/fxView/users/change_password'
import welcome from '@/components/fxView/users/welcome'
//======================trading account=====================================
import later from '@/components/fxView/registerSteps/do_later'
import openOrderList from '@/components/fxView/tradingAccounts/open_orders_listing'
import openTradeList from '@/components/fxView/tradingAccounts/open_trades_listing'
import closeTradeList from '@/components/fxView/tradingAccounts/close_trades_listing'
import createAccountLive from '@/components/fxView/tradingAccounts/create_account_live'
import createAccountDemo from '@/components/fxView/tradingAccounts/create_account'
import create_zulu_account from '@/components/fxView/tradingAccounts/create_zulu_account'
import create_ib_mamm_pamm_account from '@/components/fxView/tradingAccounts/create_ib_mamm_pamm_account'
import rest_api from '@/components/fxView/tradingAccounts/rest_api'

import web_trade_link from '@/components/fxView/tradingAccounts/web_trade_link'
import web_trade_link_live from '@/components/fxView/tradingAccounts/web_trade_link_live'
import new_web_trade_link from '@/components/fxView/tradingAccounts/web_trade_link_new'
import createSubTicket from '@/components/fxView/tradingtools/createSubTicket'


//======================manage account=====================================

import accountVerify from '@/components/fxView/manageAccounts/account-verify'
import detach_account from '@/components/fxView/manageAccounts/detach_account'
//=====================deposit================================================
import depositTransaction from '@/components/fxView/deposit/deposit_transaction'
//=====================Bonus================================================

import bonusVerify from '@/components/fxView/bonus/bonus_verify'
import loyaltyVerify from '@/components/fxView/wallet/loyality/loyalty-verify'
//=====================supports================================================


import unauthorized from '@/components/fxView/unauthorized/unauthorized'
import pendingVerification from '@/components/fxView/unauthorized/pending_verification'

//=====================tradinngTools page================================================
import api_documentation from '@/components/fxView/tradingtools/api_documentation'
import subscription_verify from '@/components/fxView/tradingtools/subscription_verify'

import wallet from '@/components/fxView/wallet/wallet'

import nuvei from '@/components/fxView/deposit/nuvei'

//========================register-steps===================================================

import steps from '@/components/fxView/registerSteps/steps'
import step_one from '@/components/fxView/registerSteps/step1'
import step_two from '@/components/fxView/registerSteps/step2'
import step_three from '@/components/fxView/registerSteps/step3'
import step_four from '@/components/fxView/registerSteps/step4'
import step_five from '@/components/fxView/registerSteps/step5'



import subsTransactionDetail from '@/components/fxView/tradingtools/subsTransactionDetail'
import sub_change_account from '@/components/fxView/tools/pages/sub_change_account'
import sub_change_account_verify from '@/components/fxView/tools/pages/sub_change_account_verify'

import unsubscribe_plan from '@/components/fxView/tools/pages/unsubscribe_plan'
import unsubscribe_verify from '@/components/fxView/tools/pages/unsubscribe_verify'





import accountfunding from '@/components/fxView/wallet/account-funding'   //this includes depsit-add/list and withdrawal - add/list pages


import account from '@/components/fxView/account/account' // account list , change-pasword internal transfer , change-leverage
import accountList from '@/components/fxView/manageAccounts/account_list'
import changeLeverage from '@/components/fxView/manageAccounts/change_leverage'
import internalTransfer from '@/components/fxView/manageAccounts/internal_transfer'
import changePassword from '@/components/fxView/manageAccounts/change_password1'


import deposit_bonus from '@/components/fxView/bonus/deposit_bonus'

import social_trade from '@/components/fxView/socialTrade/social_trade'

import tools from '@/components/fxView/tools/tools'

import research_and_education from '@/components/fxView/research/research_and_education'

import downloadplatform from '@/components/fxView/users/downloadplatform'

import support from '@/components/fxView/supports/index'
import view from '@/components/fxView/supports/view'

import refer_a_friend from '@/components/fxView/users/refer-a-friend'
import paymentCallback from '@/components/fxView/deposit/paymentCallback'

// New pages 
import chooseAccount from '@/components/fxView/registerSteps/choose-account'
import createDemoAccount from '@/components/fxView/registerSteps/create-demo-account'
import createLiveAccount from '@/components/fxView/registerSteps/create_live_account'
import holdDeposit from '@/components/fxView/deposit/hold_deposit'



import {BANK,DASHBOARD,PROFILE,TWOFA,REQUEST_VERIFY,INDEX,NOTIFICATION,TRADER_CHANGE_PASSWORD,ACCOUNT_LIST,OPEN_TRADES,OPEN_ORDERS,WITHDRAWAL,WITHDRAWAL_LIST,DEPOSIT,DEPOSIT_LIST,BONUS,BONUS_LIST,REMOVE_BONUS,SUPPORT,VIEW,CHANGE_LEVERAGE,
INTERNAL_TRANSFER,ACCOUNT_VERIFY,LS_ROUTE_KEY,CREATE_DEMO_ACCOUNT,CREATE_LIVE_ACCOUNT} from "@/consts"
import { nextTick } from 'process'
Vue.use(Router)

function hasQueryParams(route) {
  return !!Object.keys(route.query).length
}


const router =  new Router({
  mode: 'history',
  routes: [
    { path: '/', name: 'fxView.login', component: login , meta: { requiresAuth: false } },
    { path: '/register', name: 'fxView.register', component: register , meta: { requiresAuth: false } },
    { path: '/forgot-password', name: 'fxView.forgotPassword', component: forgotPassword , meta: { requiresAuth: false } },
    { path: '/forgot/password/:hash', name: 'fxView.ResetPasswordFromHash', component: ResetPasswordFromHash , meta: { requiresAuth: false } },
    { path: '/lp/insights', name: 'fxView.landingPage', component: landingPage , meta: { requiresAuth: false } },
    { path: '/create_demo_account', name: 'fxView.createDemoAccount', component: createDemoAccount, meta: { requiresAuth: false } },
    { path: '/create_live_account', name: 'fxView.createliveAccount', component: createLiveAccount, meta: { requiresAuth: false } },
    {path: '/hold-deposit',name: 'holdDeposit',component: holdDeposit, meta: { requiresAuth: false } },
    

    {
      path: '/',
      component:fxViewcomponents,
      children: [
        { path: '/choose-account', name: 'fxView.chooseAccount', component: chooseAccount , meta: { requiresAuth: true } },
        {path: '/wallet',name: 'wallet',component: wallet, meta: { requiresAuth: true } },
        {path: '/nuvei',name: 'nuvei',component: nuvei, meta: { requiresAuth: true } },
        {path: '/account-funding',name: 'accountfunding',component: accountfunding, meta: { requiresAuth: true } },
        {path: '/detach-account',name: 'detach_account',component: detach_account, meta: { requiresAuth: true } },
        {path: '/research-and-education/:tabName',name: 'research_and_education',component: research_and_education, meta: { requiresAuth: true } },
        {path: '/social-trade',name: 'social_trade',component: social_trade, meta: { requiresAuth: true } },
        {path: '/tools/:tabName',name: 'tools',component: tools, meta: { requiresAuth: true } },
        {path: '/deposit-bonus',name: 'deposit_bonus',component: deposit_bonus, meta: { requiresAuth: true } },
        { path: '/vps-subscription-verify', name: 'fxView.subscription_verify', component: subscription_verify , meta: { requiresAuth: true } },
        //====================bank=================================================
        { path: BANK, name: 'fxView.bank', component: bank , meta: { requiresAuth: true } },
        { path: '/pending', name: 'fxView.later', component: later , meta: { requiresAuth: true } },
        //====================users=================================================
        { path: DASHBOARD, name: 'fxView.dashboard', component: dashboard , meta: { requiresAuth: true } },
        { path: '/change-password', name: 'fxView.changeUserPassword', component: changeUserPassword , meta: { requiresAuth: true } },
        { path: '/subscription-detail', name: 'fxView.subsTransactionDetail', component: subsTransactionDetail, props : true , meta: { requiresAuth: true } },
        { path: PROFILE, name: 'fxView.profile', component: profile , meta: { requiresAuth: true } },
        { path: '/download-platform', name: 'fxView.downloadplatform', component: downloadplatform , meta: { requiresAuth: true } },
        { path: TWOFA, name: 'fxView.twoFa', component: twoFa , meta: { requiresAuth: true } },
        { path: NOTIFICATION, name: 'fxView.notification', component: notification , meta: { requiresAuth: true } },
        { path: REQUEST_VERIFY, name: 'fxView.request_verify', component: request_verify, props : true , meta: { requiresAuth: true } },
        { path: '/index', name: 'fxView.welcome', component: welcome , meta: { requiresAuth: true } },
        //======================manage account=====================================
        { path: '/account', name: 'account', component: account , meta: { requiresAuth: true } },
        { path: TRADER_CHANGE_PASSWORD, name: 'fxView.changePassword', component: changePassword , meta: { requiresAuth: true } },
        { path: CHANGE_LEVERAGE, name: 'fxView.changeLeverage', component: changeLeverage , meta: { requiresAuth: true } },
        { path: INTERNAL_TRANSFER, name: 'fxView.internalTransfer', component: internalTransfer , meta: { requiresAuth: true } },
        { path: ACCOUNT_LIST, name: 'fxView.accountList', component: accountList , meta: { requiresAuth: true } },
        { path: ACCOUNT_VERIFY, name: 'fxView.accountVerify', component: accountVerify , meta: { requiresAuth: true } },
        //======================trading account=====================================
        { path: OPEN_TRADES, name: 'fxView.openTradeList', component: openTradeList },
        { path: '/close-trades', name: 'fxView.closeTradeList', component: closeTradeList },
        { path: '/rest-api', name: 'fxView.rest_api', component: rest_api },
        { path: '/web-trade-link', name: 'fxView.web_trade_link', component: web_trade_link },
        { path: '/new-web-trade-link', name: 'fxView.new_web_trade_link', component: new_web_trade_link },
        { path: '/web-trade-link-live', name: 'fxView.web_trade_link_live', component: web_trade_link_live },
        { path: OPEN_ORDERS, name: 'fxView.openOrderList', component: openOrderList },
        { path: CREATE_LIVE_ACCOUNT, name: 'fxView.createAccountLive', component: createAccountLive,  meta: { requiresAuth: true } },
        { path: CREATE_DEMO_ACCOUNT, name: 'fxView.createAccountDemo', component: createAccountDemo,  meta: { requiresAuth: true } },

        // { path: '/create-demo-account', name: 'fxView.createDemoAccount', component: createDemoAccount, meta: { requiresAuth: false } },

        { path: '/create-zulu-account', name: 'fxView.createZuluAccount', component: create_zulu_account },
        { path: '/create-ib-mamm-pamm-account/:doc/:terms_conditions', name: 'fxView.createIbMamPammAccount', component: create_ib_mamm_pamm_account },
        { path: '/transaction-history', name: 'fxView.depositTransaction', component: depositTransaction },
        //=====================bonus===============================================
        { path: '/bonus-verify', name: 'fxView.bonusVerify', component: bonusVerify , meta: { requiresAuth: true } },  
        { path: '/loyalty-verify', name: 'fxView.loyaltyVerify', component: loyaltyVerify , meta: { requiresAuth: true } },
        //=====================supports============================================
        { path: SUPPORT, name: 'fxView.support', component: support , meta: { requiresAuth: true } },
        {  path: '/create-subscription-ticket',  name: 'fxView.createSubTicket',  component: createSubTicket  , meta: { requiresAuth: true } },
        { path: VIEW, name: 'fxView.view', component: view , meta: { requiresAuth: true } },
        { path: '/unauthorized', name: 'fxView.unauthorized', component: unauthorized , meta: { requiresAuth: true } },
        { path: '/pending-verification', name: 'fxView.pendingVerification', component: pendingVerification , meta: { requiresAuth: true } },
        //=====================Market subscription============================================
        { path: '/api-documentation', name: 'fxView.api_documentation', component: api_documentation , meta: { requiresAuth: true } },
        { path: '/refer-a-friend', name: 'fxView.refer_a_friend', component: refer_a_friend , meta: { requiresAuth: true } },
        { path: '/subscription-change-account', name: 'fxView.sub_change_account', component: sub_change_account , meta: { requiresAuth: true } },
        { path: '/subscription-account-verify', name: 'fxView.sub_change_account_verify', component: sub_change_account_verify , meta: { requiresAuth: true } },
        { path: '/unsubscribe-plan', name: 'fxView.unsubscribe_plan', component: unsubscribe_plan , meta: { requiresAuth: true } },
        { path: '/unsubscribe-verify', name: 'fxView.unsubscribe_verify', component: unsubscribe_verify , meta: { requiresAuth: true } },
        { path: '/paymentCallback', name: 'fxView.paymentCallback', component: paymentCallback , meta: { requiresAuth: true } },
        //========================register-steps=================================================
        {
          path : '',
          component : steps,
          children:[
            { path: '/step1', name: 'fxView.step_one', component: step_one , meta: { requiresAuth: true } },
            { path: '/step2', name: 'fxView.step_two', component: step_two , meta: { requiresAuth: true } },
            { path: '/step3', name: 'fxView.step_three', component: step_three , meta: { requiresAuth: true } },
            { path: '/step4', name: 'fxView.step_four', component: step_four , meta: { requiresAuth: true } },
            { path: '/step5', name: 'fxView.step_five', component: step_five , meta: { requiresAuth: true }}
          ]
        }
      ]
    },
    { path: "/*", redirect: "/" }
  ]
})

router.beforeEach( (to, from, next) => {
  
  const queryToken = to.query.token;

  if(queryToken){
    const data = { token: queryToken, loggedIn: true, roles: '', email: '', profile: {} }
    localStorage.setItem('user', btoa(JSON.stringify(data)))
  }

  if(!hasQueryParams(to) && hasQueryParams(from)){
    window.fz("event", {name: "pageView", value: window.location.hostname+to.path, unit: "url"});
  }else {
    window.fz("event", {name: "pageView", value: window.location.hostname+to.path, unit: "url"});
  }

  let userStateVariable = store.state.user
  if(userStateVariable == ''){
    userStateVariable= {}
  }

  if (to.name == "fxView.chooseAccount") {
    const userData = $cookies.get("user_data");
    if (userData) {
     userData.loggedIn = true;
     localStorage.setItem("user", btoa(JSON.stringify(userData)));
     store.commit(types.SET_STATE, userData);
      userStateVariable = userData;
    } else {
      console.warn("User data not found in cookies.");
    }
    next()
  }

  if(!userStateVariable.token && to.meta.requiresAuth){
   console.log("Login userStateVariable:", userStateVariable);
    next({ name: 'fxView.login' })
  }
  const publicRoutes = ['fxView.login', 'fxView.register', 'fxView.forgotPassword', 'fxView.ResetPasswordFromHash', 'fxView.landingPage'];

  if (userStateVariable.loggedIn && publicRoutes.includes(to.name)) {
    return next({ name: 'fxView.dashboard' });
  }

  if (!publicRoutes && ((userStateVariable == null || !'loggedIn' in userStateVariable) || !userStateVariable.loggedIn)) {
    console.log("Query userStateVariable:", userStateVariable);
    localStorage.setItem("lastPath", to.path);
    if(to.query.ticketData){
      localStorage.setItem("query", to.query.ticketData);
    }
    next({ name: 'fxView.login' })
  } 

  const steps = ['fxView.step_one', 'fxView.step_two', 'fxView.step_three', 'fxView.step_four'];
  
  const hasLiveAccount = userStateVariable &&
  userStateVariable.profile &&
  userStateVariable.profile.account &&
  userStateVariable.profile.account.length > 0 &&
  parseInt(userStateVariable.profile.account[0].demo_live) === 1;
  
  const hasDocuments = userStateVariable &&
    userStateVariable.profile &&
    userStateVariable.profile.documents &&
    userStateVariable.profile.documents.length > 0
    && userStateVariable.profile.documents.some((item) => {item.document_type === "Proof of Residence" })

  if (to.name == "fxView.step_five") {
    if ((to.name == "fxView.step_five") && !hasDocuments) {
      // console.log('2', hasDocuments)
      next(to.name == "fxView.step_five")
      return;
    } else if ((to.name == "fxView.step_five") && hasDocuments) {
      // console.log('3', hasDocuments)
      next({ name: 'fxView.dashboard' })
      return;
    }
    next()
  } else {
    if ((steps.includes(to.name) && userStateVariable.verified_status == 2) ||
      (steps.includes(to.name) && userStateVariable.verified_status == 0 && hasLiveAccount) ||
      (steps.includes(to.name) && hasDocuments && hasLiveAccount)
    ) {
      next({ name: 'fxView.dashboard' })
      return;
    }
    next()
  }
 
//  else next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js